/**
 * BIEU TUONG CAN LE - ve bang SVG, khong dung ky tu phong chu.
 *
 * Xem chu giai cua ALIGN_ICON_ROW_WIDTHS trong textEditCore.ts de biet vi sao
 * khong con dung Unicode. Tom tat: khong phong chu nao tren moi nen tang mang
 * san glyph can le tu te, va bo ⯇ ≡ ⯈ cu doc ra la mui ten dieu huong.
 *
 * Mau lay tu `currentColor` nen nut tu quyet dinh - trang thai .active cua
 * .propToggle doi mau chu, va bieu tuong doi theo dung nhip do. Khong ma mau
 * cung o day; lam vay la nen toi va trang thai chon se mat tuong phan.
 */
import type { TextAlign } from '../core/edit/layout';
import { ALIGN_ICON_ROW_WIDTHS, alignIconRowExtent } from './textEditCore';

/** Le trai/phai cua o ve, tinh trong he toa do 16x16 cua viewBox. */
const PAD = 2;
/** Be ngang thuc dung cho cac dong. */
const SPAN = 16 - PAD * 2;
/** Dong dau va dong cuoi, phan deu cho bon dong. */
const Y_FIRST = 3;
const Y_STEP = 3.3;

export interface AlignIconProps {
  align: TextAlign;
  /** Canh o ve tren man hinh. Mac dinh vua thanh thuoc tinh. */
  size?: number;
}

export function AlignIcon({ align, size = 14 }: AlignIconProps) {
  return (
    <svg
      className="alignIcon"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
    >
      {ALIGN_ICON_ROW_WIDTHS.map((w, i) => {
        const { start, end } = alignIconRowExtent(align, w);
        const y = Y_FIRST + i * Y_STEP;
        return (
          <line
            key={i}
            x1={PAD + start * SPAN}
            x2={PAD + end * SPAN}
            y1={y}
            y2={y}
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
          />
        );
      })}
    </svg>
  );
}
